export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6Lcmw-8qAAAAAHvWmUMGDEWz-s_hbcRpd9SBhpTu', //TO UPDATE AFTER NEW GENERATION V3 
    // www.masterfield prod : 6Lcmw-8qAAAAAHvWmUMGDEWz-s_hbcRpd9SBhpTu
  },
  gtag: {
    key: 'G-FD4ESVJFDG' //TO UPDATE BEFORE DELIVERY
  },
  // Front-end public URL (used to detect the landing page)
  frontUrl: 'https://www.masterfield.ma/',
  // Backend monolith (wam_api)
  api: {
    ip: 'https://www.masterfield.ma',
    port: '' // empty = no explicit port
  },
  // Microservices (TO UPDATE with the real prod hosts/ports)
  ms: {
    sector: { ip: 'https://www.masterfield.ma', port: '' },
    survey: { ip: 'https://www.masterfield.ma', port: '' },
    leave: { ip: 'https://www.masterfield.ma', port: '' },
    help: { ip: 'https://www.masterfield.ma', port: '' },
    message: { ip: 'https://www.masterfield.ma', port: '' }
  },
  // External links
  links: {
    jiraBrowseUrl: 'https://itimdex.atlassian.net/browse/',
    companyUrl: 'https://itimdex.com',
    masterfieldUrl: 'https://www.masterfield.ma'
  }
};
